import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dda0a360&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=dda0a360&prod&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=dda0a360&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda0a360",
  null
  
)

export default component.exports